import { render, staticRenderFns } from "./comprehensive-quality.vue?vue&type=template&id=23ae6973&scoped=true"
import script from "./comprehensive-quality.vue?vue&type=script&lang=js"
export * from "./comprehensive-quality.vue?vue&type=script&lang=js"
import style0 from "./comprehensive-quality.vue?vue&type=style&index=0&id=23ae6973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae6973",
  null
  
)

export default component.exports